import styled from 'styled-components'
import breakpoints from '../../../config/settings/breakpoints'

export const FooterWrapper = styled.div`
  grid-area: footer-content;
  margin-block-end: max(1rem, env(safe-area-inset-bottom, 0px));
  margin-block-start: 2rem;
  margin-inline-end: 1rem;
  margin-inline-start: 1rem;
  width: 100%;

  @media ${breakpoints.device.sm} {
    margin-block-start: 3rem;
  }
`

export const Container = styled.div`
  align-items: center;
  border-block-start: 1px solid ${({ theme }) => theme.colors.borderDefault};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  padding-block-start: ${({ theme }) => theme.spacing.md};
  text-align: center;
  width: 100%;

  @media ${breakpoints.device.sm} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.lg};
    justify-content: space-between;
    padding-block-start: ${({ theme }) => theme.spacing.lg};
    text-align: start;
  }
`

export const FooterBlock = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 100%;
  text-align: center;
  width: 100%;

  @media ${breakpoints.device.sm} {
    width: auto;

    &:first-child {
      justify-content: flex-start;
      text-align: start;
    }

    &:nth-child(2) {
      flex: 1;
      justify-content: center;
      text-align: center;
    }

    &:last-child {
      justify-content: flex-end;
      text-align: end;
    }
  }
`

export const BackToTopButton = styled.button`
  align-items: center;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  color: ${({ theme }) => theme.colors.textMuted};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  min-block-size: 44px;
  min-inline-size: 44px;
  padding: 0;
  transition: border-color 0.2s ease, color 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`
